import React from "react";
import ImgAtividade from '../../imgs/saude-geral/img-1.png';
import ImgAlimentacao from '../../imgs/saude-geral/img-2.png';
import ImgCigarro1 from '../../imgs/saude-geral/img-3.png';
import ImgCigarro2 from '../../imgs/saude-geral/img-4.png';
import ImgCigarro3 from '../../imgs/historia-quadrinho-3.jpeg';
import { useIsMobile } from "../../hooks/useIsMobile";

export default function HabitosSaudaveis() {
    const isMobile = useIsMobile();

    return (
        <div className="container" style={{ paddingTop: 60, paddingBottom: 60 }}>
            <h1 style={{ textAlign: 'center' }}>Hábitos Saudáveis</h1>

            <h2 style={{ textAlign: 'center' }}>Importância da atividade física</h2>
            {isMobile ? (
                <>
                    <p>
                        Fazer atividade física regularmente melhora a saúde do corpo e da mente, prevenindo doenças e dando mais disposição. Também ajuda a dormir melhor, fortalece músculos e ossos, e aumenta a autoestima.

                    </p>
                    <p>Sua saúde — física e mental — vai agradecer agora e no futuro!</p>
                </>
            ) : (
                <p>
                    Mexer o corpo faz bem para tudo — e não é só papo de adulto, não! Fazer atividade física com frequência ajuda a prevenir várias doenças, como obesidade, diabetes, pressão alta e problemas no coração. Além disso, melhora a respiração, fortalece os músculos e os ossos, ajuda a dormir melhor e até dá aquela força para manter o peso em dia. E sabe aquele cansaço ou desânimo do dia a dia? Se movimentar pode dar o gás que você precisa!
                    Além disso, praticar exercícios é ótimo para diminuir o estresse, aliviar a ansiedade, melhorar o humor e até aumentar a autoestima. Sem contar que, quando a gente se exercita com outras pessoas, rola aquele clima de amizade, respeito e trabalho em grupo. Então, seja na escola, na quadra, no parque ou em casa mesmo, o importante é sair do sofá e colocar o corpo em movimento. Sua saúde — física e mental — vai agradecer agora e no futuro!
                </p>

            )}

            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img src={ImgAtividade} alt="img-1" style={{ maxWidth: '100%', height: 'auto' }} />
            </div>

            <h2 style={{ textAlign: 'center' }}>Importância da alimentação saudável</h2>
            {isMobile ? (
                <>
                    <p>Comer de forma saudável na adolescência é essencial para o crescimento, energia e bom humor. Pratos coloridos com alimentos naturais ajudam o corpo e o cérebro a funcionarem melhor.
                    </p>
                    <p>Comer bem não significa abrir mão do sabor — dá pra fazer escolhas gostosas e inteligentes ao mesmo tempo.</p>
                </>
            ) :
                (<>
                    <p>
                        Comer de forma saudável é cuidar do corpo e da mente, principalmente na adolescência, que é uma fase cheia de mudanças e crescimento. Uma boa alimentação ajuda no desenvolvimento do cérebro, dos músculos, dá energia para encarar a escola, praticar esportes e até melhora o humor! Fazer boas escolhas na hora de comer pode parecer difícil no começo, mas faz toda a diferença na saúde, no bem-estar e até no desempenho nas atividades do dia a dia.
                    </p>
                    <p>
                        O segredo está em montar pratos coloridos e variados, com alimentos naturais ou pouco processados, como frutas, legumes, verduras, arroz, feijão, ovos e carnes. E vale tentar deixar de lado, pelo menos na maior parte do tempo, os ultraprocessados como refrigerantes, salgadinhos e embutidos, que têm muito açúcar, sal e gordura. Comer bem não significa abrir mão do sabor — dá pra fazer escolhas gostosas e inteligentes ao mesmo tempo. Seu corpo, sua mente e seu futuro vão agradecer!
                    </p>
                </>)}


            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img src={ImgAlimentacao} alt="img-2" style={{ maxWidth: '100%', height: 'auto' }} />
            </div>
            <h2 style={{ textAlign: 'center' }}>Não uso de cigarros, drogas e álcool</h2>

            {isMobile ? (
                <>
                    <p>
                        Cigarro, álcool e outras drogas fazem mal ao corpo e à mente, podendo causar doenças como câncer e transtornos mentais.
                    </p>
                    <p>Prejudicam a saúde bucal, com risco de cáries, mau hálito e até câncer de boca.</p>
                </>
            ) : (
                <>
                    <p>
                        O uso de cigarro, álcool e outras drogas pode causar muitos problemas para a saúde, tanto da boca quanto do corpo inteiro. Essas substâncias afetam a circulação, o coração, os pulmões, o fígado e até o funcionamento do cérebro. Podem levar ao desenvolvimento de doenças graves como câncer, problemas respiratórios, doenças no fígado, hipertensão e transtornos mentais. No dia a dia, isso se reflete em cansaço, falta de disposição, mudanças de humor e dificuldade de concentração, o que impacta diretamente nos estudos, nas relações e na qualidade de vida.
                    </p>
                    <p>
                        Na saúde bucal, os danos também são sérios. O uso dessas substâncias reduz a saliva, altera o pH da boca e favorece o surgimento de cáries, mau hálito e doenças na gengiva. O álcool e o cigarro, juntos, aumentam bastante o risco de câncer bucal, principalmente na língua e nas bochechas. Já drogas como crack e cocaína podem causar feridas, perda de dentes e até perfuração no céu da boca. Além disso, o descuido com a higiene bucal é comum entre usuários, o que agrava ainda mais os problemas.
                    </p>
                </>
            )}



            <div
                style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 20
                }}
            >
                <img src={ImgCigarro1} alt="img-3" style={{ maxWidth: isMobile ? '100%' : '600px', height: 'auto' }} />
                <img src={ImgCigarro2} alt="img-4" style={{ maxWidth: isMobile ? '100%' : '600px', height: 'auto' }} />
            </div>

            {isMobile ? (
                <>
                    <p>O <span style={{ fontSize: 18 }} className="atencao">cigarro eletrônico</span> também faz mal à saúde, pois contém nicotina. Ele afeta o coração, a respiração e a saúde bucal, mesmo parecendo “menos pior”. </p>
                    <p>Dizer não e fazer escolhas saudáveis é a verdadeira atitude de quem se cuida.</p>
                </>
            ) : (
                <>
                    <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                        O <span style={{ fontSize: 18 }} className="atencao">cigarro eletrônico</span>, que muita gente acha “menos pior”, também faz mal. Ele contém nicotina e outras substâncias químicas que afetam o coração, o pulmão e a boca, podendo causar inflamações, feridas e até dependência. Por fim, vale lembrar: usar essas coisas não te deixa mais legal, mais aceito ou mais popular.
                        <p>Se cuidar, dizer não e fazer escolhas saudáveis ​​mostra atitude de verdade.</p>
                    </p>
                </>
            )}

            <h2 style={{ textAlign: 'center' }}>Vamos aprender com a história do João?</h2>

            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 120 }}>
                <img src={ImgCigarro3} alt="img-5" style={{ maxWidth: '100%', height: 'auto' }} />
            </div>
        </div>
    );
}
